import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { fmtEUR } from '../lib/api';

export default function StatCard({ label, value, delta, deltaLabel, isCurrency = true, accent = false, testid }) {
  const arrow = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  const Arrow = arrow;
  const deltaColor = delta > 0 ? 'text-emerald-700' : delta < 0 ? 'text-rose-600' : 'text-zinc-500';

  return (
    <div
      data-testid={testid}
      className={`bg-white border border-zinc-200 p-6 ${accent ? 'border-l-4 border-l-[#002FA7]' : ''}`}
    >
      <div className="text-[10px] text-zinc-500 uppercase tracking-[0.2em] mb-3">{label}</div>
      <div className="font-mono font-medium text-3xl tracking-tight text-zinc-950 mb-2">
        {isCurrency ? fmtEUR(value) : value}
      </div>
      {delta !== undefined && (
        <div className={`flex items-center gap-1.5 text-xs font-mono ${deltaColor}`}>
          <Arrow size={12} strokeWidth={2} />
          <span>{isCurrency ? fmtEUR(Math.abs(delta)) : Math.abs(delta)}</span>
          {deltaLabel && <span className="text-zinc-500 font-sans ml-1">{deltaLabel}</span>}
        </div>
      )}
    </div>
  );
}
